<template>
<div class="min-w-xs font-grotesk">
	<kc-main></kc-main>
</div>
</template>
<script>
import { defineComponent } from 'vue';
import MainMenu from './components/MainMenu.vue';
import { Sort, Toolbar, Search, Filter, Group, InfiniteScroll, Grid, Edit, ForeignKey, Page, Selection, CommandColumn, ExcelExport} from '@syncfusion/ej2-vue-grids';
import { L10n } from "@syncfusion/ej2-base";
import syncfusionTexts from "./syncfusion/localization"
L10n.load(syncfusionTexts);
export default defineComponent({
	name: 'App',
	components: {
		'kc-main' : MainMenu
	},
	provide: {
		grid: [Sort, Toolbar, Search, Group, Filter, InfiniteScroll, Grid, Edit, ForeignKey, Page, Selection, CommandColumn , ExcelExport],
	}
})
</script>
<style>
	@import "../../node_modules/@syncfusion/ej2-base/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-vue-grids/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-vue-navigations/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-vue-calendars/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-vue-buttons/styles/tailwind.css";
	@import "../../node_modules/@syncfusion/ej2-vue-popups/styles/tailwind.css";
</style>
